export default __webpack_public_path__ + "static/media/ecto-logo-full.12ac8dad.svg";